"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var shippingPriceStyle = (0, _emotion.css)(_templateObject());

var Price =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Price, _PureComponent);

  function Price() {
    (0, _classCallCheck2.default)(this, Price);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Price).apply(this, arguments));
  }

  (0, _createClass2.default)(Price, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          price = _this$props.price,
          currency = _this$props.currency,
          quantity = _this$props.quantity,
          priceMode = _this$props.priceMode,
          shippingPrice = _this$props.shippingPrice,
          shippingCurrency = _this$props.shippingCurrency;
      var displayShippingPrice;
      var displayPrice;

      if (price === undefined || price === null) {
        displayPrice = '-';
        displayShippingPrice = '';
      } else {
        var calculatedPrice = priceMode === 'item' && quantity ? price / quantity : price;
        displayPrice = calculatedPrice.toLocaleString(undefined, {
          style: 'currency',
          currency: currency
        });

        if (shippingPrice === undefined || shippingPrice === null) {
          displayShippingPrice = '';
        } else {
          displayShippingPrice = shippingPrice.toLocaleString(undefined, {
            style: 'currency',
            currency: shippingCurrency
          });
          displayShippingPrice = displayShippingPrice ? "+ Shipping ".concat(displayShippingPrice) : '';
        }
      }

      return _react.default.createElement("td", {
        className: "pricing-cell contract-price"
      }, _react.default.createElement("span", null, displayPrice), _react.default.createElement("br", null), _react.default.createElement("span", {
        className: shippingPriceStyle
      }, displayShippingPrice));
    }
  }]);
  return Price;
}(_react.PureComponent);

exports.default = Price;